import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SystemSettings } from '../models/system-settings.model';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {
  private url = environment.url;

  constructor(private http: HttpClient) {}

  getSettings(): Observable<SystemSettings> {
    return this.http.get<any>(`${this.url}system-settings`)
      .pipe(map(data => SystemSettings.adapt(data)));
  }

  addFormalApprover(employeeId: number): Observable<any> {
    return this.http.post(`${this.url}system-settings/formal-approvers/${employeeId}`, {});
  }

  removeFormalApprover(employeeId: number): Observable<any> {
    return this.http.delete(`${this.url}system-settings/formal-approvers/${employeeId}`);
  }

  updateDescription(description: string): Observable<any> {
    return this.http.patch(`${this.url}system-settings/description`, { description });
  }
}
